import { Timestamp } from '@bufbuild/protobuf';
import { Box } from '@mui/material';
import { QuestionMetaInfo_SpecialQuestionEnum } from '@protos/content_management/content.db_pb';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { TeacherUploadedTag } from '../TeacherUploadedTag';
import { TextbookQuestionTag } from '../TextbookQuestionTag';

export type QuestionSourceTagQuestion = {
  createdBy?: bigint;
  createdOn?: Timestamp;
  questionMeta?: {
    specialQuestion?: QuestionMetaInfo_SpecialQuestionEnum[];
  };
};

export const isTextbookQuestion = (
  question?: QuestionSourceTagQuestion | null
): boolean =>
  !!question?.questionMeta?.specialQuestion?.includes(
    QuestionMetaInfo_SpecialQuestionEnum.SPECIAL_QUESTION_TEXTBOOK
  );

export const isTeacherUploadedQuestion = (
  question?: QuestionSourceTagQuestion | null,
  teacherProfileId?: bigint | string | null
): boolean => {
  if (teacherProfileId == null || question?.createdBy == null) return false;
  return question.createdBy.toString() === teacherProfileId.toString();
};

interface QuestionSourceTagsProps {
  question?: QuestionSourceTagQuestion | null;
  teacherProfileId?: bigint | string | null;
  teacherName?: string;
}

export const QuestionSourceTags = ({
  question,
  teacherProfileId,
  teacherName = '',
}: QuestionSourceTagsProps) => {
  const showTeacherUploaded = isTeacherUploadedQuestion(
    question,
    teacherProfileId
  );
  const showTextbook = isTextbookQuestion(question);

  if (!showTeacherUploaded && !showTextbook) {
    return <></>;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: { xs: pxToRem(6), md: pxTovW(8) },
        marginLeft: '5px',
      }}
    >
      {showTeacherUploaded ? (
        <TeacherUploadedTag
          teacherName={teacherName}
          createdOn={question?.createdOn || new Timestamp()}
        />
      ) : null}
      {showTextbook ? <TextbookQuestionTag /> : null}
    </Box>
  );
};
